import type { CustomChartBarOrientation, CustomChartColor, CustomChartSize, CustomChartType } from './types';

export const TREND_TYPES = {
  ASC: 'asc',
  DESC: 'desc',
} as const;

/** Каталог типов диаграмм пользовательского дашборда в порядке показа пользователю. */
export const CUSTOM_CHART_TYPES: readonly CustomChartType[] = [
  'metric',
  'text-summary',
  'heatmap',
  'table',
  'grouped-table',
  'bar',
  'pie',
  'line',
  'conversation-list',
  'selection-breakdown',
] as const;

/** Размеры диаграммы от узкого к широкому — доля ширины сетки дашборда. */
export const CUSTOM_CHART_SIZES: readonly CustomChartSize[] = ['1/5', '1/4', '1/3', '1/2', 'full'] as const;

/**
 * Размеры, рекомендуемые для типа диаграммы: предлагаются первыми, но выбор пользователя
 * ими не ограничен — доступен любой размер из {@link CUSTOM_CHART_SIZES}.
 */
export const RECOMMENDED_CHART_SIZES: Record<CustomChartType, CustomChartSize[]> = {
  metric: ['1/5', '1/4'],
  'text-summary': ['1/3', '1/2', 'full'],
  heatmap: ['1/2', 'full'],
  table: ['1/2', 'full'],
  'grouped-table': ['1/2', 'full'],
  bar: ['1/3', '1/2', 'full'],
  pie: ['1/3', '1/2'],
  line: ['1/2', 'full'],
  'conversation-list': ['1/3', '1/2', 'full'],
  'selection-breakdown': ['1/3', '1/2', 'full'],
};

/** Направления элементов столбчатой диаграммы; первое — то, каким она показана без выбора. */
export const CUSTOM_CHART_BAR_ORIENTATIONS: readonly CustomChartBarOrientation[] = ['horizontal', 'vertical'] as const;

/**
 * Набор цветов диаграмм, из которого пользователь выбирает цвет категории и цвет правила
 * раскраски: десять цветов палитры долей и три цвета шкалы зон качества.
 */
export const CUSTOM_CHART_COLORS: readonly CustomChartColor[] = [
  'slice-1',
  'slice-2',
  'slice-3',
  'slice-4',
  'slice-5',
  'slice-6',
  'slice-7',
  'slice-8',
  'slice-9',
  'slice-10',
  'zone-green',
  'zone-yellow',
  'zone-red',
] as const;

/**
 * Минимальное число диаграмм в пользовательском дашборде. Сверху состав не ограничен: он растёт
 * строками сетки, а пять диаграмм в строке — предел её ширины, а не состава.
 */
export const MIN_PRESET_CHARTS = 1;

/** Предельная длина описания данных диаграммы — граница задана контрактом истолкования. */
export const CHART_DESCRIPTION_MAX_LENGTH = 1000;

/** Наименьшая длина описания данных диаграммы, при которой бэкенд берётся его истолковать. */
export const CHART_DESCRIPTION_MIN_LENGTH = 3;

/** Предельная длина текста результата диаграммы — граница задана контрактом правила. */
export const CHART_RESULT_TEMPLATE_MAX_LENGTH = 2000;
